import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar = (): JSX.Element => {
	return (
		<nav className="sidebar">
			<Link to="/" className="sidebar-link">Home</Link>
			<Link to="/leaders" className="sidebar-link">Leaders</Link>
			<Link to="/rewards" className="sidebar-link">Rewards</Link>
		</nav>
	);
};

export default Sidebar;
